import { styled } from 'styled-components';

export const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
`;

export const ChatMessages = styled.div`
  flex: 1;
  overflow-y: auto;
  background-color: #ffffff;
  padding: 15px;
  box-sizing: border-box;
`;

export const ChatForm = styled.form`
  display: flex;
  gap: 10px;
  padding: 10px;
  background-color: #f7fafc;
  box-sizing: border-box;
  border-top: 1px solid #e2e8f0;
`;

export const ChatTextArea = styled.textarea`
  flex: 1;
  padding: 10px;
  background-color: #ffffff;
  border: 1px solid #cbd5e0;
  color: #2d3748;
  border-radius: 5px;
  resize: vertical;
`;

export const ChatMessageUser = styled.div`
  color: #2d3748;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #bee3f8;
  border-radius: 8px;
  font-weight: 500;
`;

export const ChatMessageAssistant = styled.div`
  color: #2d3748;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #f7fafc;
  border-radius: 8px;
  white-space: pre-wrap;
  word-wrap: break-word;
  border: 1px solid #e2e8f0;
`;

export const ChatMessageSystem = styled.div`
  color: #2d3748;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #fefcbf;
  border-radius: 8px;
  white-space: pre-wrap;
  word-wrap: break-word;
  border: 1px solid #f6e05e;
`;

export const ChatMessageClickable = styled.div`
  cursor: pointer;
`;

export const ChatMessageContent = styled.span`
  white-space: pre-wrap;
`;

export const ProcessingStatusBar = styled.div<{ $show: boolean }>`
  height: ${props => props.$show ? '30px' : '0'};
  overflow: hidden;
  transition: height 0.3s ease-in-out;
  background: linear-gradient(270deg, #667eea, #764ba2, #667eea);
  background-size: 200% 200%;
  animation: gradientMove 3s ease infinite;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 20px;
  color: white;
  font-weight: 500;
  font-size: 13px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);

  @keyframes gradientMove {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

export const ProcessingTimer = styled.span`
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Fira Code', 'Droid Sans Mono', 'Source Code Pro', monospace;
  letter-spacing: 0.5px;
  margin-right: 8px;
`;

export const StageRunStatusRow = styled.div<{ $status: 'idle' | 'waiting' | 'running' | 'complete' | 'failed' }>`
  padding: 12px 15px;
  background-color: ${props => {
    if (props.$status === 'waiting' || props.$status === 'running') {
      return 'transparent';
    }
    return '#f7fafc';
  }};
  ${props => (props.$status === 'waiting' || props.$status === 'running') && `
    background: linear-gradient(270deg, #f0f4ff, #e8f0fe, #f0f9ff, #f0f4ff);
    background-size: 300% 300%;
    animation: gradientMove 4s ease infinite;
  `}
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  font-size: 14px;
  color: #2d3748;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  @keyframes gradientMove {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

export const StageRunStatusText = styled.span<{ $status: 'idle' | 'running' | 'complete' | 'failed' }>`
  font-weight: 500;
  color: ${props => {
    switch (props.$status) {
      case 'running': return '#3182ce';
      case 'complete': return '#38a169';
      case 'failed': return '#e53e3e';
      default: return '#718096';
    }
  }};
`;

export const StageRunButton = styled.button`
  padding: 6px 12px;
  background-color: #3182ce;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color: #2c5aa0;
  }

  &:disabled {
    background-color: #cbd5e0;
    cursor: not-allowed;
  }
`;

export const ResultOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const ResultModal = styled.div`
  background-color: white;
  border-radius: 8px;
  max-width: 800px;
  max-height: 80vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

export const ResultHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ResultTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
`;

export const ResultCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #718096;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f7fafc;
  }
`;

export const ResultContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  white-space: pre-wrap;
  word-wrap: break-word;
  color: #2d3748;
  line-height: 1.6;
`;
